<template>
  <div class="plat-class-teacher-distribute-class-grade">
    <div class="header">
      <el-checkbox v-model="checkAll"
                   :indeterminate="isIndeterminate"
                   @change="handleCheckAllChange">{{gradeName}}（{{checked.length}}/{{grade.clazzList.length}}）</el-checkbox>
    </div>
    <div class="grade-cont">
      <el-checkbox-group v-model="checked"
                         @change="handleCheckedChange">

        <el-checkbox v-for="clazz in grade.clazzList"
                     :key="clazz.id"
                     :label="clazz.id">{{clazz.name}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatClassTeacherDistributeClassGrade',
  props: {
    value: {
      type: Array,
      required: true
    },
    gradeName: {
      type: String,
      required: true
    },
    grade: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      checked: [],
      checkAll: false,
      isIndeterminate: true
    }
  },
  methods: {
    handleCheckAllChange (val) {
      this.$emit('input', val ? this.grade.clazzList.map(clazz => clazz.id) : [])
      this.isIndeterminate = false
    },
    handleCheckedChange (val) {
      let checkedCount = val.length
      this.checkAll = checkedCount === this.grade.clazzList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.grade.clazzList.length
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.checked = val
        this.handleCheckedChange(this.checked)
      },
      immediate: true
    },
    checked (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
  .plat-class-teacher-distribute-class-grade {
    & > .header {
      padding-left: 12px;
      padding-right: 12px;
      .el-checkbox {
        .el-checkbox__label {
          font-size: 12px;
        }
      }
    }
    & > .grade-cont {
      margin-top: 10px;
      padding: 6px 12px;
      box-sizing: border-box;
      background-color: #fff;
      border: 1px solid #ebeef5;
      .el-checkbox-group {
        .el-checkbox {
          margin-top: 3px;
          margin-bottom: 3px;
          .el-checkbox__label {
            font-size: 12px;
            min-width: 160px;
          }
        }
      }
    }
    & + .plat-class-teacher-distribute-class-grade {
      margin-top: 15px;
    }
  }
</style>
